export default __webpack_public_path__ + "static/media/Iconly-Heart.2c5a214b.svg";